import type { Locale } from './locale';

/**
 * Date format patterns (date-fns tokens) for chart labels by locale. The date module formats
 * `YYYY-MM-DD` days with them into each locale's short chart-axis form.
 *
 * Format examples:
 * - en: "Oct. 16" (abbreviated month with a period, day without leading zero)
 * - nb: "16. okt." (day with period, abbreviated month, which carries its own period)
 * - es: "16 oct." (the Spanish short month carries its own period)
 *
 * The nb and es short month names already end in a period where the word is cut, so the
 * patterns do not add one.
 */
export const CHART_LABEL_DATE_FORMATS: Record<Locale, string> = {
    en: 'MMM. d', // Oct. 16
    nb: 'd. MMM', // 16. okt.
    es: 'd MMM', // 16 oct.
};

/**
 * Gets the date format pattern for chart labels based on locale
 * @param locale - The locale to get the format for
 * @returns date-fns format pattern for the locale
 *
 * @example
 * getChartLabelDateFormat('en'); // "MMM. d" → "Oct. 16"
 * getChartLabelDateFormat('nb'); // "d. MMM" → "16. okt."
 * getChartLabelDateFormat('es'); // "d MMM" → "16 oct."
 */
export function getChartLabelDateFormat(locale: Locale): string {
    return CHART_LABEL_DATE_FORMATS[locale];
}
